<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper" v-if="!deviceData">
      <a-form @keyup.enter.native="searchQuery" layout="inline">
        <a-row :gutter="24">
          <a-col :lg="6" :md="6" :sm="24" :xl="6">
            <a-form-item label="供水流域">
              <j-dict-select-tag
                @change="searchQuery"
                dictCode="`iwt-wf`.dev_process,process_name,id"
                placeholder="请选择供水流域"
                v-model="queryParam.devProcessId"
              />
            </a-form-item>
          </a-col>
          <a-col :lg="6" :md="6" :sm="24" :xl="6">
            <a-form-item label="设备">
              <j-search-select-tag
                @change="searchQuery"
                dict="`iwt-wf`.dev_list,dev_name,id, del_flag=0  order by sort asc"
                placeholder="请选择设备"
                v-model="queryParam.devId"
              />
            </a-form-item>
          </a-col>
          <a-col :lg="6" :md="6" :sm="24" :xl="6">
            <a-form-item label="测点名称">
              <a-input allowClear placeholder="请输入测点名称" v-model="queryParam.pointName"></a-input>
            </a-form-item>
          </a-col>
          <a-col :lg="6" :md="6" :sm="24" :xl="6">
            <a-form-item label="点号">
              <a-input allowClear placeholder="请输入点号" v-model="queryParam.pointCode"></a-input>
            </a-form-item>
          </a-col>

          <a-col :lg="4" :md="4" :sm="24" :xl="4">
            <a-form-item label="位号">
              <a-input allowClear placeholder="请输入位号" v-model="queryParam.pointTag"></a-input>
            </a-form-item>
          </a-col>

          <a-col :lg="5" :md="5" :sm="24" :xl="5">
            <a-form-item label="数据类型">
              <j-dict-select-tag
                @change="searchQuery"
                dictCode="point_data_type"
                placeholder="请选择数据类型"
                type="list"
                v-model="queryParam.dataType"
              />
            </a-form-item>
          </a-col>

          <a-col :lg="5" :md="5" :sm="24" :xl="5">
            <a-form-item label="数据来源">
              <j-dict-select-tag
                @change="searchQuery"
                dictCode="point_data_source"
                placeholder="请选择数据来源"
                type="list"
                v-model="queryParam.dataSource"
              />
            </a-form-item>
          </a-col>
          <a-col :lg="4" :md="4" :sm="24" :xl="4">
            <a-form-item>
              <j-multi-select-tag
                :options="[{ label: '重要测点', value: '1' }]"
                @change="searchQuery"
                type="checkbox"
                v-model="queryParam.isProImportant"
              />
            </a-form-item>
          </a-col>

          <a-col :lg="4" :md="4" :sm="24" :xl="4">
            <span class="table-page-search-submitButtons" style="float: left;overflow: hidden;">
              <a-button @click="searchQuery" icon="search" type="primary">查询</a-button>
              <a-button @click="searchReset" icon="reload" style="margin-left: 8px" type="primary">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" icon="plus" type="primary">新增</a-button>
      <!-- <a-button @click="checkDataSource" icon="edit" style="margin-left: 8px" v-if="this.hasDeviceId">配置运行条件</a-button> -->
      <a-button @click="handleExportXls('监测点')" icon="download" type="primary" v-if="!this.hasDeviceId">导出</a-button>
      <!-- <a-checkbox @change="importPointCheck" v-model="importpointChecked">只看重要测点</a-checkbox> -->
      <a-upload
        :action="importExcelUrl"
        :headers="tokenHeader"
        :multiple="false"
        :showUploadList="false"
        @change="handleImportExcel"
        name="file"
        v-if="!this.hasDeviceId"
      >
        <a-button icon="import" type="primary" v-if="!this.hasDeviceId">导入</a-button>
      </a-upload>
      <!-- 高级查询区域 -->
      <j-super-query
        :fieldList="superFieldList"
        @handleSuperQuery="handleSuperQuery"
        ref="superQueryModal"
        v-if="!this.hasDeviceId"
      ></j-super-query>
      <a-button @click="updateTsdbTags" icon="reload" style="margin-left: 8px" v-if="!this.hasDeviceId">同步配置</a-button>
      <a-button @click="initDevStatusPoints" icon="plus-circle" style="margin-left: 8px" v-if="!this.hasDeviceId">设备状态测点</a-button>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item @click="relateBatch" key="1" v-if="!hasDeviceId">
            <a-icon type="retweet" />批量关联
          </a-menu-item>
          <a-menu-item @click="batchDelFn(1)" key="1" v-if="hasDeviceId">
            <a-icon type="delete" />删除
          </a-menu-item>
          <a-menu-item @click="batchDelFn(2)" key="2" v-else>
            <a-icon type="delete" />删除
          </a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px">
          批量操作
          <a-icon type="down" />
        </a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a @click="onClearSelected" style="margin-left: 24px">清空</a>
      </div>

      <a-table
        :columns="columns"
        :customRow="customRowRender"
        :dataSource="dataSource"
        :loading="loading"
        :pagination="importpointChecked ? false : ipagination"
        :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :scroll="{ x: true }"
        @change="handleTableChange"
        bordered
        class="j-table-force-nowrap point-table"
        ref="table"
        rowKey="id"
        size="middle"
      >
        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span style="font-size: 12px;font-style: italic;" v-if="!text">无图片</span>
          <img
            :src="getImgView(text)"
            alt
            height="25px"
            style="max-width:80px;font-size: 12px;font-style: italic;"
            v-else
          />
        </template>
        <template slot="important" slot-scope="option, record">
          <a-switch
            :checked="Boolean(Number(record.isProImportant))"
            @change="onCellChange(record.isProImportant, record, $event)"
            v-if="idType == 'devProcessId'"
          ></a-switch>
          <span v-else>{{ record.isProImportant_dictText }}</span>
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span style="font-size: 12px;font-style: italic;" v-if="!text">无文件</span>
          <a-button :ghost="true" @click="downloadFile(text)" icon="download" size="small" type="primary" v-else>下载</a-button>
        </template>
        <!-- pointCode -->
        <template slot="valueColor" slot-scope="text, record">
          <div :style="getValueColStyle(record)">{{ getValueColText(text, record) }}</div>
        </template>
        <span slot="devName" slot-scope="text, record">
          <link-to-detail :id="record.devId" pageType="drawer" route-name="FusionDevice">
            <span>{{ text }}</span>
          </link-to-detail>
        </span>
        <span slot="action" slot-scope="text, record" v-if="!hasDeviceId">
          <a @click="handleCopy(record)">复制</a>
          <a-divider type="vertical" />
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">
              更多
              <a-icon type="down" />
            </a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleDetail(record)">查看详情</a>
              </a-menu-item>
              <a-menu-item>
                <a @click="dataHistory(record)">历史数据</a>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
        <span slot="action" slot-scope="text, record" v-else>
          <a @click="handleDetail(record)">查看详情</a>
          <a-divider type="vertical" />
          <a @click="dataHistory(record)">历史数据</a>
        </span>
      </a-table>
    </div>

    <a-modal :width="1100" @ok="configCondition" title="运行条件判断" v-if="hasDeviceId" v-model="conditionModalVisibal">
      <a-row :gutter="[16, 16]">
        <a-col :span="12">
          <a-form-model-item :labelCol="labelCol2" :wrapperCol="wrapperCol" label="测点" prop="pointCode">
            <a-select
              :options="dataSource.map(item => ({ value: item.pointCode, label: item.pointName }))"
              placeholder="请选择"
              style="width:100%"
              v-model="runCondition.pointCode"
            ></a-select>
          </a-form-model-item>
        </a-col>
        <a-col :span="6">
          <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="判断条件" prop="judgingCondition">
            <a-select placeholder="请选择" style="width:100%" v-model="runCondition.judgingCondition">
              <a-select-option value=">">&gt;</a-select-option>
              <a-select-option value="==">=</a-select-option>
              <a-select-option value="<">&lt;</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :span="6">
          <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="判断值" prop="judgingValue">
            <a-input-number
              id="inputNumber"
              placeholder="请输入判断值"
              style="width:100%"
              v-model="runCondition.judgingValue"
            />
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-modal>

    <iot-model-points-modal :deviceData="deviceData" @ok="modalFormOk" ref="modalForm"></iot-model-points-modal>
    <iot-model-points-modal-detail :deviceData="deviceData" :idType="idType" @ok="modalFormOk" ref="modalFormDetail" />

    <relate-modal @ok="modalFormOk" ref="relateModal"></relate-modal>
    <points-line-chart-modal ref="pointsDataLineModal"></points-line-chart-modal>
  </a-card>
</template>

<script>
  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import PointsLineChartModal from '@views/monitor/datas/modules/PointsLineChartModal'
  import IotModelPointsModal from './modules/IotModelPointsModal'
  import IotModelPointsModalDetail from './modules/IotModelPointsModalForDetail.vue'
  import RelateModal from './modules/RelateModal'
  import { getAction, httpAction, putAction } from '@/api/manage'
  import { DragTableMixin } from '@/mixins/DragTableMixin'

  import { filterMultiDictText } from '@/components/dict/JDictSelectUtil'
  import { validatenull, validatenotnull } from '@/utils/validate'
  import moment from 'dayjs'

  export default {
    name: 'IotModelPointsList',
    mixins: [JeecgListMixin, mixinDevice, DragTableMixin],
    components: {
      PointsLineChartModal,
      IotModelPointsModal,
      IotModelPointsModalDetail,
      RelateModal
    },
    props: {
      deviceData: {
        type: Object,
        default: () => { }
      },
      idType: {
        type: String,
        default: ''
      }
    },
    data () {
      return {
        dragTableClass: 'point-table',
        importpointChecked: false,
        description: '监测点管理页面',
        isorter: {
          column: 'devProcessSort',

          // column: 'pointName',
          order: 'asc'
        },
        // 表头
        columns: [
          {
            title: '测点名称',
            align: 'center',
            dataIndex: 'pointName',
            ellipsis: true,
            width: '150px',
            sorter: true
          },
          {
            title: '点号',
            align: 'center',
            dataIndex: 'pointCode',
            sorter: true
          },
          {
            title: '当前值时间戳',
            align: 'center',
            dataIndex: 'timeSeriesDetail.timeStamp',
            customRender: function (text) {
              return !text ? '' : text.length > 19 ? text.substr(0, 19) : text
            }
          },
          {
            title: '当前值',
            align: 'right',
            dataIndex: 'timeSeriesDetail.value'
            // scopedSlots: { customRender: 'valueColor' }
          },
          {
            title: '计量单位',
            align: 'center',
            dataIndex: 'dataUnit'
          },
          {
            title: '设备',
            align: 'center',
            dataIndex: 'devId_dictText',
            scopedSlots: { customRender: 'devName' },
            sorter: true
          },
          {
            title: '数据类型',
            align: 'center',
            dataIndex: 'dataType_dictText',
            sorter: true
          },
          {
            title: '数据来源',
            align: 'center',
            dataIndex: 'dataSource_dictText'
          },
          //   {
          //     title: '业务属性',
          //     align: 'center',
          //     dataIndex: 'dataCategory'
          //   },
          //   {
          //     title: '是否工艺重要测点',
          //     align: 'center',
          //     dataIndex: 'isProImportant',
          //     scopedSlots: { customRender: 'important' }
          //   },
          {
            title: '量程上限',
            align: 'center',
            dataIndex: 'toprange'
          },
          {
            title: '量程下限',
            align: 'center',
            dataIndex: 'botrange'
          },

          {
            title: '操作',
            dataIndex: 'action',
            align: 'center',
            fixed: 'right',
            width: 167,
            scopedSlots: { customRender: 'action' }
          }
        ],
        // ipagination: {
        //   current: 1,
        //   pageSize: 50,
        //   pageSizeOptions: ['50', '100', '200'],
        //   showTotal: (total, range) => {
        //     return range[0] + '-' + range[1] + ' 共' + total + '条'
        //   },
        //   showQuickJumper: true,
        //   showSizeChanger: true,
        //   total: 0
        // },
        conditionModalVisibal: false,
        url: {
          list: '/monitor/iotModelPoints/list',
          delete: '/monitor/iotModelPoints/delete',
          deleteBatch: '/monitor/iotModelPoints/deleteBatch',
          exportXlsUrl: '/monitor/iotModelPoints/exportXls',
          importExcelUrl: '/monitor/iotModelPoints/importExcel',
          editBatch: '/monitor/iotModelPoints/editBatch',
          editDev: '/device/devList/edit',
          addDevWorkingConditions: '/device/devWorkingConditions/add',
          queryById: '/device/devWorkingConditions/queryById',
          syncdb: 'monitor/iotModelPoints/syncdb',
          initDevStatusPoints: 'monitor/iotModelPoints/initDevStatusPoints'
        },
        dictOptions: {},
        superFieldList: [],
        disableMixinCreated: true,
        runCondition: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 8 }
        },
        labelCol2: {
          xs: { span: 24 },
          sm: { span: 4 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 }
        },
        modalFormShow: false,
        colorList: {},
        sourceObj: {},
        targetObj: {},
        DragTableloading: true
      }
    },

    async created () {
      await this.loadColor()

      if (this.deviceData && this.deviceData.id) {
        this.queryParam[this.idType] = this.deviceData.id
        const columnsForChildren = [
          'pointName',
          'dataType_dictText',
          'dataUnit_dictText',
          'dataSource_dictText',
          'timeSeriesDetail.value',
          'timeSeriesDetail.timeStamp'
        ]
        let columns = this.columns.reduce((pre, cur) => {
          if (columnsForChildren.includes(cur.dataIndex)) {
            pre.push(cur)
          }
          return pre
        }, [])
        // if (this.idType === 'devProcessId') {
        //   columns.push({
        //     title: '是否工艺重要测点',
        //     align: 'center',
        //     dataIndex: 'isProImportant',
        //     scopedSlots: { customRender: 'important' }
        //   })
        // }
        this.columns = columns.concat({
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          fixed: 'right',
          width: 147,
          scopedSlots: { customRender: 'action' }
        })
      }
      this.getSuperFieldList()
      if (this.idType == '') {
        this.loadData()
      }

      // 初始化websocket
      // this.initWebSocket()
      this.loadColor()
    },
    computed: {
      hasDeviceId () {
        return this.deviceData && this.deviceData.id
      },
      importExcelUrl: function () {
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
      }
    },
    watch: {
      hasDeviceId: {
        immediate: true,
        handler: function (val) {
          if (val) {
            // if (this.deviceData.id) {
            this.queryParam[this.idType] = val
            this.loadData()
            // }
          }
        }
      }
    },
    methods: {
      customRow (record, index) {
        return {
          attrs: {
            draggable: 'true'
          },
          style: {
            cursor: 'pointer'
          },
          // 鼠标移入
          onMouseenter: event => {
            // 兼容IE
            var ev = event || window.event
            ev.target.draggable = true
          },
          // 开始拖拽
          onDragstart: event => {
            // 兼容IE
            var ev = event || window.event
            // 阻止冒泡
            ev.stopPropagation()
            // 得到源目标数据
            sourceObj = record
          },
          // 拖动元素经过的元素
          onDragover: event => {
            // 兼容 IE
            var ev = event || window.event
            // 阻止默认行为
            ev.preventDefault()
          },
          // 鼠标松开
          onDrop: event => {
            // 兼容IE
            var ev = event || window.event
            // 阻止冒泡
            ev.stopPropagation()
            // 得到目标数据
            targetObj = record
            if (sourceObj.sortId != targetObj.sortId) {
              var temp = undefined
              temp = sourceObj.sortId
              sourceObj.sortId = targetObj.sortId
              targetObj.sortId = temp
            }
            debugger
            // saveDrop();// 调用业务API完成需求，这个根据自己的业务来
          }
        }
      },
      async tableSortFn (record, newId, oldId) {
        if (!this.importpointChecked) return
        const url = '/monitor/iotModelPoints/editProcessPointSort'
        const params = this.dataSource.map((item, index) => {
          return {
            pointCode: item.pointCode,
            devProcessSort: index
          }
        })
        this.loading = true
        try {
          const res = await putAction(url, params)
          if (res && res.success) {
            this.$message.success(res.message)
          }
          this.loading = false
        } catch (error) {
          this.loading = false
        }
      },
      async importPointCheck (v) {
        console.info('importpointChecked==', this.importpointChecked)
        if (!this.importpointChecked) {
          this.ipagination.current = 1
          this.loadData()

          this.destroyed()
          return
        }
        this.loading = true
        const params = this.getQueryParams() // 查询条件
        try {
          const res = await getAction(this.url.list, {
            isProImportant: 1,
            ...params
          })
          if (res && res.success) {
            this.dataSource = res.result.records
            this.initSortable()
          }
          this.loading = false
        } catch (error) {
          this.loading = false
        }

        // this.handleTableChange()
      },
      async loadColor () {
        const colorData = await getAction('/custom/category/childListByPCode', {
          pCode: 'A08A01'
        })

        if (colorData.success) {
          const color = colorData.result
            .map(({ name, cusProp1 }) => ({
              name,
              cusProp1
            }))
            .reduce((pre, cur) => {
              pre[cur.name] = cur.cusProp1
              return pre
            }, {})

          this.colorList = color
        }
      },
      onCellChange (v, e) {
        const that = this
        // 触发表单验证
        that.confirmLoading = true
        let method = 'put'

        const params = Object.assign(e, {
          isProImportant: !v ? 1 : 0
        })

        httpAction('/monitor/iotModelPoints/edit', params, 'put')
          .then(res => {
            if (res.success) {
              that.$message.success('设置成功')
              that.loadData()
            } else {
              that.$message.warning('设置失败')
            }
          })
          .finally(() => {
            that.confirmLoading = false
          })
      },
      loadData (arg) {
        if (!this.url.list) {
          this.$message.error('请设置url.list属性!')
          return
        }
        // 加载数据 若传入参数1则加载第一页的内容
        if (arg === 1) {
          this.ipagination.current = 1
        }
        var params = this.getQueryParams() // 查询条件
        if (params.pointCode) {
          params.pointCode = `*${params.pointCode}*`
        }
        this.loading = true
        getAction(this.url.list, params)
          .then(res => {
            if (res.success) {
              this.dataSource = res.result.records || res.result
              if (res.result.total) {
                this.ipagination.total = res.result.total
              } else {
                this.ipagination.total = 0
              }
            } else {
              this.$message.warning(res.message)
            }
          })
          .finally(() => {
            this.loading = false
          })
      },
      handleAdd: function () {
        const ref = this.hasDeviceId ? 'modalFormDetail' : 'modalForm'
        this.$refs[ref].add()
        this.$refs[ref].title = '新增'
        this.$refs[ref].disableSubmit = false
      },
      handleCopy (record) {
        this.$refs['modalForm'].copy(record)
        this.$refs['modalForm'].title = '另存为'
        this.$refs['modalForm'].disableSubmit = false
      },
      handleDetail (record) {
        // const ref = this.hasDeviceId ? 'modalFormDetail' : 'modalForm'
        const ref = 'modalForm'
        this.$refs[ref].edit(record)
        this.$refs[ref].title = '详情'
        this.$refs[ref].disableSubmit = true
      },
      relateBatch () {
        if (this.selectionRows.length <= 0) {
          this.$message.warning('请选择一条记录！')
        } else {
          let pointCodes = ''
          for (var a = 0; a < this.selectionRows.length; a++) {
            pointCodes += this.selectionRows[a].pointCode + ','
          }

          const ref = 'relateModal'
          this.$refs[ref].edit(pointCodes)
          this.$refs[ref].title = '关联'
        }
      },
      updateTsdbTags () {
        httpAction(this.url.syncdb, {}, 'post').then(res => {
          if (res.success) {
            $message.success(res.message)
          } else {
            this.$message.warning('同步失败，请稍后尝试')
          }
        })
      },
      initDevStatusPoints () {
        httpAction(this.url.initDevStatusPoints, {}, 'post').then(res => {
          if (res.success) {
            this.loadData()
          } else {
            this.$message.warning('创建失败，请稍后尝试')
          }
        })
      },
      handleEdit: function (record) {
        const ref = this.hasDeviceId ? 'modalFormDetail' : 'modalForm'

        this.$refs[ref].edit(record)
        this.$refs[ref].title = '编辑'
        this.$refs[ref].disableSubmit = false
      },
      configCondition () {
        httpAction(
          this.url.addDevWorkingConditions,
          Object.assign({ id: this.deviceData.id }, this.runCondition),
          'post'
        ).then(res => {
          if (res.success) {
            this.conditionModalVisibal = false
          } else {
            this.$message.warning('设置运行条件失败')
          }
        })
      },
      batchDelFn (type) {
        // 1 代表非详情页相关测点
        if (type === 1) {
          const that = this
          // 触发表单验证
          that.confirmLoading = true
          let method = 'put'
          const params = this.selectionRows.map(item => {
            item[this.idType] = ''
            return item
          })

          // await httpAction(this.url.edit, element, method)
          // that.$emit('ok')
          httpAction(this.url.editBatch, params, method)
            .then(res => {
              if (res.success) {
                that.$message.success(res.message)
                that.loadData()
              } else {
                that.$message.warning(res.message)
              }
            })
            .finally(() => {
              that.confirmLoading = false
            })
        } else {
          this.batchDel()
        }
      },

      handleDelete: function (record) {
        if (!this.url.delete) {
          this.$message.error('请设置url.delete属性!')
          return
        }
        var that = this
        if (!this.hasDeviceId) {
          deleteAction(that.url.delete, { id: record.id }).then(res => {
            if (res.success) {
              // 重新计算分页问题
              that.reCalculatePage(1)
              that.$message.success(res.message)
              that.loadData()
            } else {
              that.$message.warning(res.message)
            }
          })
        } else {
          const deleteData = Object.assign(record, { [this.idType]: '' })
          httpAction('/monitor/iotModelPoints/edit', deleteData, 'put').then(res => {
            if (res.success) {
              that.$message.success('删除成功')
              this.loadData()
            } else {
              that.$message.warning('删除失败')
            }
          })
        }
      },
      initDictConfig () { },
      getSuperFieldList () {
        let fieldList = []
        fieldList.push({
          type: 'sel_search',
          value: 'devId',
          text: '设备',
          dictTable: '`iwt-wf`.dev_list',
          dictText: 'dev_name',
          dictCode: 'id'
        })
        fieldList.push({
          type: 'int',
          value: 'devProcessId',
          text: '供水流域',
          dictCode: '`iwt-wf`.dev_process,process_name,id'
        })
        fieldList.push({ type: 'string', value: 'hubCode', text: '网关编码', dictCode: '' })
        fieldList.push({ type: 'string', value: 'pointName', text: '测点名称', dictCode: '' })
        fieldList.push({ type: 'string', value: 'pointCode', text: '点号', dictCode: '' })
        fieldList.push({ type: 'string', value: 'pointTag', text: '位号', dictCode: '' })
        fieldList.push({ type: 'string', value: 'dataType', text: '数据类型', dictCode: 'point_data_type' })
        fieldList.push({ type: 'string', value: 'dataUnit', text: '计量单位', dictCode: '' })
        fieldList.push({ type: 'string', value: 'dataSource', text: '数据来源', dictCode: 'point_data_source' })
        fieldList.push({ type: 'string', value: 'dataCategory', text: '业务属性', dictCode: '' })
        fieldList.push({ type: 'int', value: 'readonly', text: '是否只读', dictCode: 'yn' })
        fieldList.push({ type: 'BigDecimal', value: 'toprange', text: '量程上限', dictCode: '' })
        fieldList.push({ type: 'BigDecimal', value: 'botrange', text: '量程下限', dictCode: '' })
        fieldList.push({ type: 'BigDecimal', value: 'multi', text: '倍率', dictCode: '' })
        fieldList.push({ type: 'BigDecimal', value: 'shift', text: '偏移', dictCode: '' })
        fieldList.push({ type: 'int', value: 'trend', text: '变化趋势', dictCode: 'point_data_trend' })
        fieldList.push({ type: 'int', value: 'tenantId', text: '租户id', dictCode: '' })
        fieldList.push({ type: 'string', value: 'orgId', text: '公司id', dictCode: '' })
        fieldList.push({ type: 'int', value: 'delFlag', text: '删除状态', dictCode: '' })
        this.superFieldList = fieldList
      },
      checkDataSource () {
        if (validatenull(this.dataSource) || this.dataSource.length == 0) {
          this.$message.warning('请先配置相关测点')
        } else {
          let params = { id: this.deviceData.id }
          getAction(this.url.queryById, params).then(res => {
            if (res.success) {
              this.runCondition = res.result
              this.conditionModalVisibal = true
            } else {
              if (res.message == '未找到对应数据') {
                this.$message.warning('未找到对应数据' + ',请配置运行条件！')
                this.runCondition = {}
                this.conditionModalVisibal = true
              } else {
                this.$message.warning(res.message)
              }
            }
          })
        }
      },
      dataHistory (record) {
        const pointCode = record.pointCode
        this.$refs.pointsDataLineModal.show(pointCode)
      },
      initWebSocket: function () {
        var url = window._CONFIG['realtimeWsURL']
        this.websock = new WebSocket(url)
        this.websock.onopen = this.websocketonopen
        this.websock.onerror = this.websocketonerror
        this.websock.onmessage = this.websocketonmessage
        this.websock.onclose = this.websocketclose
      },
      websocketonmessage: function (e) {
        var data = JSON.parse(e.data)
        // 处理订阅信息
        if (data.topic == 'realtime') {
          const realData = data.payload
          realData.forEach(_point => {
            this.dataSource.forEach(_row => {
              if (_row.pointCode.toLocaleUpperCase() === _point.tag.toLocaleUpperCase()) {
                _row.timeSeriesDetail = {
                  value: _point.value,
                  time: _point.time,
                  timeStamp: _point.time
                }
              }
            })
          })
        }
      },
      getValueColStyle (row) {
        let style = {}
        if (row.pointCode.toLocaleUpperCase().includes('_ALARM')) {
          style['color'] = '#fff'
          style['background-color'] = row.timeSeriesDetail.value == 1 ? this.colorList.stop : this.colorList.run
        } else if (row.pointCode.toLocaleUpperCase().endsWith('RUN')) {
          style['color'] = '#fff'
          style['background-color'] = row.timeSeriesDetail.value == 1 ? this.colorList.run : this.colorList.stop
        } else if (row.pointCode.toLocaleUpperCase().endsWith('STATE')) {
          style['color'] = '#fff'
          style['background-color'] = row.timeSeriesDetail.value == 1 ? this.colorList.run : this.colorList.stop
        }
        return style
      },
      getValueColText (text, row) {
        if (!row.timeSeriesDetail) {
          return '--'
        }
        if (row.dataType === 'BOOL') {
          if (row.pointCode.toLocaleUpperCase().includes('_ALARM')) {
            text = row.timeSeriesDetail.value == 1 ? '报警' : '正常'
          } else if (row.pointCode.toLocaleUpperCase().endsWith('RUN')) {
            text = row.timeSeriesDetail.value == 1 ? '运行' : '停止'
          } else if (row.pointCode.toLocaleUpperCase().endsWith('STATE')) {
            text = row.timeSeriesDetail.value == 1 ? '运行' : '停止'
          }
        } else if (row.dataType === 'int') {
          text = parseInt(row.timeSeriesDetail.value, 10)
        }
        return text
      }
    }
  }
</script>
<style scoped>

  @import '~@assets/less/common.less';

</style>
